export const resolveMongoObjectId = (obj: any): string => {
  let id: string;
  if (obj) {
    id = obj;
  }
  if (obj && obj['_id']) {
    id = obj['_id'];
  }
  return id;
};
